export default "__VITE_ASSET__BvpoYVZb__"